import React from "react";
import aboutImage from "../Images/Image/view-heavy-machinery-used-construction-industry (2).jpg";
import firstImage from "../Images/Image/view-heavy-machinery-used-construction-industry (1).jpg";
import "../css/AboutDetails.css";
import ProfileCard from "../components/ProfileCard";
import "../App.css";

const AboutDetails = () => {
  return (
    <section className="about-details" style={{ margin: 0, padding: 0 }}>
      
      {/* IMAGE */}
      <div style={{ position: 'relative', height: '350px', overflow: 'hidden', margin: 0 }}>
        <img 
          src={aboutImage} 
          alt="About Us" 
          style={{ width: '100%', height: '100%', display: 'block', filter: 'brightness(0.6)', objectFit: 'cover' }}
        />
        <h1 style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          fontSize: '48px',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
          margin: 0
        }}>
          ABOUT US
        </h1>
      </div>
      
      <div className="about-details-container">

        {/* LEFT CONTENT */}
        <div className="about-text" style={{ marginTop: '20px' }}>
          <span className="section-tag">OUR INTRODUCTION</span>

          <h2>
            FOR A BETTER FUTURE <br /> KNOW ABOUT US !
          </h2>

          <p>
            Discover how SKT Construction is shaping the future of machinery
            rental with our commitment to quality, innovation, and customer
            satisfaction. We provide reliable equipment and exceptional service
            to support your projects and drive your success.
          </p>
        </div>

        {/* RIGHT QUOTE BOX */}
        <div className="about-quote">
          <p>
            “Among others, we stand out as the best with our expert team and
            skilled professionals. At SKT Construction, our dedicated staff
            ensures that you receive top-notch machinery and unparalleled
            service.”
          </p>

          <ul>
            <li>✔ Quality Control System, 100% Satisfaction Guarantee</li>
            <li>✔ Top-quality machinery with reliable maintenance</li>
            <li>✔ Unrivalled workmanship, Professional and Qualified</li>
          </ul>
        </div>

      </div>

      {/* IMAGE + CARDS */}
      <div className="about-bottom">

        <div className="about-cards" style={{ marginTop: '-20px' }}>

          <div className="info-card light">
            <h4>Our Mission</h4>
            <p>
              To provide top-quality machinery and outstanding service,
              ensuring our clients’ projects are completed efficiently.
            </p>
          </div>

          <div className="info-card dark">
            <h4>Our Vision</h4>
            <p>
              To lead in machinery rental by delivering reliable equipment
              and exceptional service.
            </p>
          </div>

          <div className="info-card light">
            <h4>Our Value</h4>
            <p>
              Commitment to reliability, integrity, and customer-focused
              service.
            </p>
          </div>

        </div>

        <div className="about-image">
          <img src={firstImage} alt="Machinery" style={{ height: '500px', width: 'auto' }} />
        </div>

      </div>

      <ProfileCard />
    </section>
  );
};

export default AboutDetails;
